// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import slabrEntity from './entities/slabr.json';
import slabrMenu from '../pages/slabr/menu.json';
import slabrFullForm from '../pages/slabr/forms/full.json';
import slabrContextForm from '../pages/slabr/forms/context.json';
import slabrMiniForm from '../pages/slabr/forms/mini.json';
import slabrLookupForm from '../pages/slabr/forms/lookup.json';
import slabrTableView from '../pages/slabr/views/table.json';
import slabrStagesView from '../pages/slabr/views/stages.json';
import slabrCardsView from '../pages/slabr/views/cards.json';
import slabrInlineView from '../pages/slabr/views/inline.json';
import slabrBacklogView from '../pages/slabr/views/backlog.json';
import slabrSplitView from '../pages/slabr/views/split.json';
import slabrCalendarView from '../pages/slabr/views/calendar.json';
import slabrDashboardView from '../pages/slabr/views/dashboard.json';

/** Тип запису «Порушення SLA» зі сторінками пакета: меню, форми та подання з pages/slabr/. */
export const slabrDefinition: IRecordTypeDefinition = {
  ...slabrEntity,
  views: assembleViewSet({
      table: slabrTableView,
      stages: slabrStagesView,
      cards: slabrCardsView,
      inline: slabrInlineView,
      backlog: slabrBacklogView,
      split: slabrSplitView,
      calendar: slabrCalendarView,
      dashboard: slabrDashboardView,
  }),
  form: slabrFullForm,
  forms: { full: slabrFullForm, context: slabrContextForm, mini: slabrMiniForm, lookup: slabrLookupForm },
  menu: slabrMenu,
} as IRecordTypeDefinition;
